import { render, staticRenderFns } from "./settleList.vue?vue&type=template&id=fd810268&"
import script from "./settleList.vue?vue&type=script&lang=js&"
export * from "./settleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports